import { render, staticRenderFns } from "./ContentFormFields.vue?vue&type=template&id=bea7d0b6&"
import script from "./ContentFormFields.vue?vue&type=script&lang=js&"
export * from "./ContentFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports